import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

const BreadCrumb = ({ title, pageTitle, t }) => {
  return (
    <Row className="w-100 m-0">
      <Col xs={12} className="p-0">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between m-0 mb-2">
          <h4 className="mb-sm-0">{t(`${title}`)}</h4>

          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {pageTitle && (
                <li className="breadcrumb-item active">{pageTitle}</li>
              )}
              <li className="breadcrumb-item active">{title}</li>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

BreadCrumb.propTypes = {
  title: PropTypes.string,
  pageTitle: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(BreadCrumb);
